import React from "react";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import "bootstrap/dist/css/bootstrap.css";
import "./SkeletonGameSlateInformation.css";

function SkeletonGameSlateInformation() {

    const color = "#6c757d";
    const hightlightColor = "#495057";

    return (
        <div
          className="modal-dialog modal-lg modal-dialog-centered" role="document">    
            <div className="modal-content">
                <SkeletonTheme color={color} highlightColor={hightlightColor}>
                    <div className="modal-header d-flex bg-dark">
                        <div className="mt-1 align-items-center">
                            <Skeleton width={100} height={30}/>
                        </div>
                        <div className="mt-1 align-items-center ml-2">
                            <Skeleton width={100} height={30}/>
                        </div>
                        <button
                            type="button"
                            class="close align-items-center text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </SkeletonTheme>
                <div className="bg-black">
                    <SkeletonTheme color={color} highlightColor={hightlightColor}>
                        <div className="bg-black">
                            <ul className="list-group list-group-horizontal">
                                <div className="m-2 pl-2">
                                    <Skeleton width={100} height={30}/>
                                </div>
                                <div className="m-2 pl-2">
                                    <Skeleton width={100} height={30}/>
                                </div>
                            </ul>
                        </div>
                        <div className="bg-black">
                            <div className="d-flex justify-content-center align-items-center bg-dark p-2">
                                <h4 className="align-items-center align-self-center text-white">
                                    <Skeleton width={150} height={40}/>
                                </h4>
                            </div>
                            <div className="container-fluid bg-black">
                                <div className="card m-1 p-0 bg-secondary" data-dismiss="modal">
                                    <div className="card-body m-1 p-0">
                                        <div className="d-flex justify-content-between m-0 p-0">
                                            <div className="m-0 p-0">
                                                <p className="text-white m-0 ml-1">
                                                    <b>
                                                        <Skeleton width={100}/>
                                                    </b>
                                                </p>
                                                <p className="m-0 mt-1 ml-1">
                                                    <Skeleton width={100}/>
                                                </p>
                                                <p className="p-1 m-0">
                                                    <Skeleton width={80} height={35}/>
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-red mr-2">
                                                    <b><Skeleton width={90}/></b>
                                                </p>
                                            </div>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SkeletonTheme>
                </div>
            </div>
        </div>      
    );
}

export default SkeletonGameSlateInformation;